var CaseStudiesSearch = {
    csResultsPerPage: 9,
    csExcludeId: 0,
    csRootId: 0,
    csCurrentResultPage: 1,

    docType: "caseStudyItem",
    partialView: "CaseStudiesResult_Rows",

    csResultTarget: null,
    loadMoreTarget: null,
    buttonTabs: null,

    me: this,

    InitCaseStudiesSearch: function (_resultsPerPage, _highlightedArticle, _rootId) {
        this.csResultsPerPage = _resultsPerPage;
        this.csExcludeId = _highlightedArticle;
        this.csRootId = _rootId;
        this.csResultTarget = document.querySelector('#nextPageOfResults');
        //this.loadMoreTarget = document.querySelector('#loadMoreNews');
        this.buttonTabs = document.getElementById('buttonTabs');

        //this.loadMoreTarget.addEventListener("click", function (e) {
        //    e.preventDefault();
        //    //console.log('load more');
        //    this.DoSearch();
        //}.bind(this));

        this.buttonTabs.addEventListener('click', (e) => {
            if (e.target.tagName === 'BUTTON') {
                var buttonTab = this.buttonTabs.querySelectorAll('button');
                buttonTab.forEach(b => b.classList.remove('active'));
                e.target.classList.add('active');
            }
        });

        document.querySelectorAll('.search__aggregation input[type=checkbox]').forEach(function (key) {
            key.addEventListener("change", function (e) {
                e.preventDefault();
                this.DoSearch();
            }.bind(this));
        }.bind(this));

        this.DoSiteSearch();

        this.DoSearch();
    },

    DoSearch: function () {
        let prom = this.GetSearchResults(1);
        prom.then(
            function (result) {
                $('#search__results').html(result.htmlResults);
                $('#pagination_search').pagination({
                    items: result.totalResultCount,
                    itemsOnPage: this.csResultsPerPage,
                    cssStyle: 'light-theme',
                    onPageClick: function (pageNumber, event) {
                        this.DoAjaxSearch(pageNumber);
                        scrollToAnchorIDOffset('topOfSearch'); ('topOfSearch');
                    }.bind(this),
                    onInit: function () {
                        console.log('Init paging');
                        var resultCount = 0;
                        if (result.totalResultCount !== null) {
                            resultCount = result.totalResultCount;
                        }
                        this.DoPagination(resultCount, 1);
                    }.bind(this)
                });
            }.bind(this)   // Bind the parent scope to this
        );
    },

    DoSiteSearch: function () {
        let prom = this.GetSiteSearchResults();
        prom.then(
            function (result) {
                //console.log(this);
                if (this.csCurrentResultPage < result.pages) {
                    this.loadMoreTarget.classList.remove('hidden')
                } else {
                    this.loadMoreTarget.classList.add('hidden')
                }

                this.csResultTarget.innerHTML = result.htmlResults;
                this.csCurrentResultPage++;
            }.bind(this)   // Bind the parent scope to this
        );
    },

    SetToggle: function (toggleValue) {
        this.eventToggle = toggleValue;
        //document.querySelector('#eventToggle').value = toggleValue;
        this.csCurrentResultPage = 1;  // Reset the pagination
        this.DoSearch(); // Trigger a new search with the updated news/events toggle
    },

    DoPagination: function (resultCount, currentPage) {
        var $pagination = $('#pagination_search');

        console.log('Page results count : %o - Per page : %o', resultCount, this.csResultsPerPage);

        if (resultCount !== null && resultCount > this.csResultsPerPage) {
            $pagination.pagination('destroy');
            $pagination.pagination('updateItems', resultCount);
            $pagination.pagination('drawPage', currentPage);
            $pagination.show();
        } else {
            $pagination.hide();
        }
    },

    DoAjaxSearch: function (pageNo) {
        var prom = this.GetSearchResults(pageNo);
        prom.then(
            function (result) {
                console.log("Processing ajax results : %o", result);

                $('#search__results').html(result.htmlResults);

                this.DoPagination(result.totalResultCount, pageNo);

                scrollToAnchorIDOffset('topOfSearch');
            }.bind(this)
        );
    },

    GetSearchParams: function (pageNo) {
        //var peopleFilter = nodeListToIds(document.querySelectorAll('.search__aggregation input[type=checkbox][data-group="people"]'));

        var params = {
            resultsPerPage: this.csResultsPerPage,
            rootNode: this.csRootId,
            excludeId: this.csExcludeId,
            currentResultPage: pageNo,
            searchSpecificDocType: this.docType,
            partialView: this.partialView,
            dateFilterField: 'displayDateIndex',
            eventToggle: this.eventToggle,  // Pass the toggle value to the controller

            // Facets
            //people: peopleFilter
        };

        console.log(params);

        return params;
    },

    GetSearchResults: function (pageNo) {
        let searchParams = this.GetSearchParams(pageNo);

        return new Promise(function (resolve, reject) {
            fetch('/umbraco/surface/CaseStudySearch/DoCaseStudySearchView', {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
                .then(function (response) {
                    //console.log('response : %o', response.json());
                    resolve(response.json());
                })
                .catch(error => {
                    console.log('Failed', error);
                    reject(error);
                });
        });
    },

    GetSiteSearchResults: function () {
        let searchParams = this.GetSearchParams();

        return new Promise(function (resolve, reject) {
            fetch('/umbraco/surface/CaseStudySearch/DoSiteSearchView', {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
                .then(function (response) {
                    //console.log('response : %o', response.json());
                    resolve(response.json());
                })
                .catch(error => {
                    console.log('Failed', error);
                    reject(error);
                });
        });
    }
}